import React, { useState } from 'react'

import { ExporterProps } from 'components/deckPage/modals/Export/types'

import ToastService from 'services/toast.service'

import PhatButton from 'components/formElements/PhatButton'
import CheckboxDropdown from 'components/formElements/CheckboxDropdown'

import { download } from 'utils/downloadHelper'
import { buildCsvFile, Options } from './helper'

import genericStyles from 'components/deckPage/modals/Export/generic.module.scss'
import Checkbox from 'components/formElements/Checkbox'

export const fileGenerator = buildCsvFile

const CSVFile = ({ selectedCards, fileName = 'archidekt_export', onSubmit }: ExporterProps) => {
  const [options, setOptions] = useState(['quantity', 'name'])

  const optionState: Options = {
    header: options.includes('header'),
    quantity: options.includes('quantity'),
    name: options.includes('name'),
    edition: options.includes('edition'),
    editionCode: options.includes('editionCode'),
    category: options.includes('category'),
    secondaryCategories: options.includes('secondaryCategories'),
    label: options.includes('label'),
    price: options.includes('price'),
    collection: options.includes('collection'),
    modifier: options.includes('modifier'),
    collectorNumber: options.includes('collectorNumber'),
    salt: options.includes('salt'),
    color: options.includes('color'),
    cmc: options.includes('cmc'),
    rarity: options.includes('rarity'),
    scryfallId: options.includes('scryfallId'),
    types: options.includes('types'),
    cardText: options.includes('cardText'),
  }

  const fileContents = buildCsvFile(selectedCards, optionState)

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(fileContents)

      ToastService.create('Copied to clipboard', 'Deck Export', 'success')
    } catch {
      ToastService.create('Unable to copy to clipboard', 'Deck Export')
    }
  }

  const handleDownload = () => {
    try {
      download(`${fileName.toLowerCase().replace(' ', '_')}.csv`, fileContents)
    } catch {
      ToastService.create('Unable to download file', 'Deck export', 'error')
    }
  }

  return (
    <div>
      <CheckboxDropdown
        includeSelectAllNoneOptions
        header="Enabled columns"
        onChange={setOptions}
        value={options}
        options={[
          { label: 'Quantity', id: 'quantity' },
          { label: 'Name', id: 'name' },
          { label: 'Edition name', id: 'edition' },
          { label: 'Edition Code', id: 'editionCode' },
          { label: 'Collector Number', id: 'collectorNumber' },
          { label: 'Category', id: 'category' },
          { label: 'Secondary Categories', id: 'secondaryCategories' },
          { label: 'Label', id: 'label' },
          { label: 'Price', id: 'price' },
          { label: 'Collection', id: 'collection' },
          { label: 'Modifier', id: 'modifier' },
          { label: 'Salt', id: 'salt' },
          { label: 'Color', id: 'color' },
          { label: 'Mana value', id: 'cmc' },
          { label: 'Rarity', id: 'rarity' },
          { label: 'Scryfall ID', id: 'scryfallId' },
          { label: 'Types', id: 'types' },
          { label: 'Card Text', id: 'cardText' },
        ]}
      />

      <Checkbox
        label="Include header line as first line (eg: quantity,name,edition name, etc)"
        checked={optionState.header}
        onChange={() =>
          optionState.header ? options.filter(value => value != 'header') : setOptions([...options, 'header'])
        }
      />

      <div className={genericStyles.controls}>
        {!onSubmit && (
          <PhatButton icon="copy outline" onClick={handleCopy} color="blue">
            Copy
          </PhatButton>
        )}

        <PhatButton
          icon="download"
          color="green"
          onClick={() => (!onSubmit ? handleDownload() : onSubmit(optionState))}>
          Download
        </PhatButton>
      </div>
    </div>
  )
}

export default CSVFile
